<template>
    <div class="router-view-content">
        <h1>Konferencje</h1>
        <h2>Edytuj konferencję z listy lub dodaj nowy</h2>
        <div
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0;
            "
        >
            <input placeholder="Szukaj" @input="search" type="search" />
            <div class="flex-row">
                <ActionButton
                    label="Dodaj konferencję"
                    color="apple"
                    @click="goToCreator"
                />
            </div>
        </div>
        <RegularList
            @itemSelected="editConference"
            :loading="initLoading"
            :header="listHeader"
            :items="listItems"
        />
        <transition name="fade">
            <ConferenceCreator
                @close="creatorVisible = false"
                v-if="creatorVisible"
            />
        </transition>
    </div>
</template>
<script>
import { timeout } from 'q'
export default {
    components: {
        ConferenceCreator: () => import('./ConferenceCreator')
    },
    data() {
        return {
            listHeader: [
                {
                    display: 'Tytuł',
                    size: 2
                },
                {
                    display: 'Widoczna?',
                    size: 2
                }
            ],
            webinars: [],
            creatorVisible: false,
            initLoading: true,
            timeout: timeout
        }
    },
    computed: {
        listItems() {
            return this.$store.state.content.conferences.map(conference => {
                return {
                    key: conference.uuid,
                    payload: conference,
                    cells: [
                        {
                            type: 'text',
                            display: conference.title,
                            size: 2
                        },
                        {
                            type: 'text',
                            display: conference.visible ? 'Tak' : 'Nie',
                            size: 2
                        }
                    ]
                }
            })
        }
    },
    methods: {
        editConference(conference) {
            this.$router.push(`conferences/${conference.id}`)
        },
        search(input) {
            const search = `"*${input.target.value}*"`
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                const query = `?query=(title=i=${search}))`
                this.getConferences(query)
            }, 1000)
        },
        goToCreator() {
            this.$router.push('conferences/new')
        },
        getConferences(q) {
            this.$store
                .dispatch('content/getConferences', q)
                .catch(error => {
                    this.$Network.handleError(error)
                })
                .then(() => {
                    this.initLoading = false
                })
        }
    },
    mounted() {
        this.getConferences()
    }
}
</script>
